/* ==========================================================================
   THE PURNA — storefront behaviour
   Vanilla, no dependencies. Progressive: every feature degrades to a normal
   link/form submit if JS fails.
   ========================================================================== */
(function () {
  'use strict';

  var money = window.Theme && window.Theme.moneyFormat ? window.Theme.moneyFormat : 'Rs. {{amount}}';
  var routes = (window.Theme && window.Theme.routes) || {};

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var frac = parts[1];
    // Indian grouping: last 3 digits, then pairs (1,23,456)
    var last3 = whole.slice(-3);
    var rest = whole.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    return money
      .replace(/\{\{\s*amount\s*\}\}/, last3 + '.' + frac)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, last3)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, last3 + ',' + frac)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, last3);
  }

  /* --- Overlay / drawer plumbing ---------------------------------------- */
  var overlay = document.querySelector('[data-overlay]');
  var openPanel = null;
  var lastFocus = null;

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function close() {
    if (!openPanel) return;
    openPanel.setAttribute('data-open', 'false');
    openPanel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    openPanel = null;
  }

  function open(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) close();
    lastFocus = document.activeElement;
    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    lockScroll(true);
    openPanel = panel;
    var focusable = panel.querySelector('[autofocus], input:not([type=hidden]), button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-panel]');
    if (opener) {
      e.preventDefault();
      open(document.querySelector(opener.getAttribute('data-open-panel')));
      return;
    }
    if (e.target.closest('[data-close-panel]')) { e.preventDefault(); close(); }
  });

  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      close();
      document.querySelectorAll('.nav__item[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
    // Trap focus inside an open panel
    if (e.key === 'Tab' && openPanel) {
      var items = openPanel.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* --- Mega menu: close on outside click, one at a time ------------------ */
  var megaItems = document.querySelectorAll('.nav__item');
  megaItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      megaItems.forEach(function (o) { if (o !== item) o.removeAttribute('open'); });
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav__item')) return;
    megaItems.forEach(function (o) { o.removeAttribute('open'); });
  });

  /* --- Header shadow on scroll ------------------------------------------ */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    // Keep the CSS sticky offset honest
    var setH = function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setH();
    window.addEventListener('resize', setH);
  }

  /* --- Cart ------------------------------------------------------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function renderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = cartDrawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function addToCart(id, qty, button) {
    if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        return refreshCartDrawer().then(function () { open(cartDrawer); });
      })
      .catch(function (err) {
        var msg = document.querySelector('[data-cart-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else alert(err.message);
      })
      .finally(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  function changeLine(key, quantity, node) {
    if (node) node.classList.add('loading');
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        // On the cart page a reload keeps totals, discounts and shipping honest.
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCartDrawer();
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-to-cart'), 1, add);
      return;
    }
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      e.preventDefault();
      var wrap = (minus || plus).closest('.qty');
      var input = wrap.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0, remove.closest('.cart-line'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0, input.closest('.cart-line'));
  });

  /* --- Product form: variants + submit ---------------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-submit]');
    var priceHost = form.closest('[data-product-root]').querySelector('[data-price-host]');
    var stockHost = form.closest('[data-product-root]').querySelector('[data-stock-host]');

    function currentOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function match(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }

    function update() {
      var variant = match(currentOptions());
      if (!variant) {
        if (submit) { submit.textContent = window.Theme.strings.unavailable; submit.setAttribute('aria-disabled', 'true'); }
        return;
      }
      if (idInput) idInput.value = variant.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (priceHost) {
        var html = '<span class="price__now">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__was">' + formatMoney(variant.compare_at_price) + '</s>';
          html += '<span class="price__off">' + window.Theme.strings.save + ' ' +
                  Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%</span>';
        }
        priceHost.innerHTML = html;
      }

      if (submit) {
        if (variant.available) {
          submit.textContent = window.Theme.strings.add_to_cart;
          submit.removeAttribute('aria-disabled');
          submit.disabled = false;
        } else {
          submit.textContent = window.Theme.strings.sold_out;
          submit.setAttribute('aria-disabled', 'true');
          submit.disabled = true;
        }
      }
      if (stockHost) {
        stockHost.innerHTML = variant.available
          ? '<span class="dot"></span>' + window.Theme.strings.in_stock
          : '<span class="dot dot--out"></span>' + window.Theme.strings.sold_out;
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    form.addEventListener('submit', function (e) {
      if (!routes.cart_add_url) return; // let it post normally
      e.preventDefault();
      var qty = form.querySelector('[name="quantity"]');
      addToCart(idInput.value, parseInt(qty ? qty.value : 1, 10) || 1, submit);
    });
  });

  /* --- Product gallery: click a thumb to swap the lead image ------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      e.preventDefault();
      var lead = gallery.querySelector('[data-lead-img]');
      if (!lead) return;
      var img = thumb.querySelector('img');
      lead.src = img.getAttribute('data-full') || img.src;
      lead.srcset = '';
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* --- Sticky buy bar (mobile) ------------------------------------------ */
  var buybar = document.querySelector('[data-buybar]');
  var mainSubmit = document.querySelector('[data-product-form] [data-submit]');

  if (buybar && mainSubmit) {
    // Clicking the bar delegates to the real button so variant + quantity hold.
    buybar.querySelector('[data-buybar-add]').addEventListener('click', function () {
      mainSubmit.click();
    });

    // Mirror the real button's state whenever variant selection changes it.
    var mirror = function () {
      var bar = buybar.querySelector('[data-buybar-add]');
      bar.textContent = mainSubmit.textContent;
      bar.disabled = mainSubmit.disabled;
      var live = document.querySelector('[data-price-host]');
      var host = buybar.querySelector('[data-buybar-price]');
      if (live && host) host.innerHTML = live.innerHTML;
    };
    new MutationObserver(mirror).observe(mainSubmit, {
      childList: true, characterData: true, subtree: true, attributes: true
    });

    // Reveal only once the real button has scrolled out of view.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top > 0;
          buybar.setAttribute('data-show', !entry.isIntersecting && !below ? 'true' : 'false');
        });
      }, { threshold: 0 }).observe(mainSubmit);
    }
  }

  /* --- Predictive search ------------------------------------------------ */
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchPanel) {
    var input = searchPanel.querySelector('[data-search-input]');
    var results = searchPanel.querySelector('[data-search-results]');
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 240);
    });
  }

  /* --- Collection sort: submit on change -------------------------------- */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* --- Reveal on scroll -------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
